import { render, staticRenderFns } from "./UpdateBalanceDialog.vue?vue&type=template&id=3df5f1ef&"
import script from "./UpdateBalanceDialog.vue?vue&type=script&lang=js&"
export * from "./UpdateBalanceDialog.vue?vue&type=script&lang=js&"
import style0 from "./UpdateBalanceDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VDialog,VForm,VIcon,VTextField,VTextarea})
